import api from "../services/api";
import globalToast from "../components/common/globalToast";

const service_path = '/price-groups.php';

export function getPriceGroups() {

    const response = api.get(service_path);

    return response;
};

export function getPriceGroupDetails(id, setData) {

    api.get(`${service_path}?id=${id}`)
        .then(response => {

            const { data } = response;

            if (data.success) {
                setData(data.data);
            } else {
                globalToast.error('Houve um erro ao carregar o conteúdo desta página!');
            };
        })
        .catch(error => {
            console.log(error);
            globalToast.error('Houve um erro ao carregar o conteúdo desta página!');
        });
};

export function createPriceGroup(data, navigateBack) {

    api.post(service_path, data)
        .then(response => {

            const { data } = response;

            if (data.success) {
                globalToast.success("PriceGroupo cadastrado com sucesso!");
                navigateBack();
            } else {
                globalToast.error(data.message);
            };
        })
        .catch(error => {
            console.log(error);
            globalToast.error('Houve um erro ao executar essa ação!');
        });
};

export function updatePriceGroup(data, navigateBack) {

    api.patch(service_path, data)
        .then(response => {

            const { data } = response;

            if (data.success) {
                globalToast.success("PriceGroupo editado com sucesso!");
                navigateBack();
            } else {
                globalToast.error(data.message);
            };
        })
        .catch(error => {
            console.log(error);
            globalToast.error('Houve um erro ao executar essa ação!');
        });
};

export function deletePriceGroup(id, user_id) {
    api.delete(service_path, { data: { id, user_id } })
        .then(response => {
            const { data } = response;
            if (data.success) {
                globalToast.success("Grupo de preços deletado com sucesso!")
            } else {
                globalToast.error('Houve um erro ao deletar o grupo de preços!');
            };
        });
};